<template>
  <b-modal id="orders-modal" :title="$t('menu.orders', 'Orders')" size="lg" ok-only>
    <!-- Рендеринг таблицы заказов для больших экранов -->
    <b-table
        v-if="!isMobile"
        size="sm"
        :items="paginatedOrders"
        :fields="fields"
        small
        striped></b-table>

    <!-- Рендеринг таблицы заказов для мобильных устройств -->
    <div v-else class="mobile-orders-list">
      <b-card
          v-for="order in paginatedOrders"
          :key="order.id"
          class="mb-2 order-card"
          no-body>
        <b-card-header class="d-flex justify-content-between align-items-center py-2">
          <span class="font-weight-bold">Order #{{ order.id }}</span>
          <b-badge :variant="getStatusVariant(order.status)">{{ order.status }}</b-badge>
        </b-card-header>
        <b-card-body class="py-2">
          <div class="d-flex justify-content-between mb-1">
            <span class="text-muted">Date:</span>
            <span>{{ order.date }}</span>
          </div>
          <div class="d-flex justify-content-between mb-1">
            <span class="text-muted">Payment:</span>
            <span>{{ order.type }}</span>
          </div>
          <div class="d-flex justify-content-between">
            <span class="text-muted">Price:</span>
            <span class="font-weight-bold">{{ order.price }}</span>
          </div>
        </b-card-body>
      </b-card>
    </div>

    <b-pagination
        v-model="currentPage"
        :total-rows="formattedOrders.length"
        :per-page="perPage"
        align="center"
        class="mt-3"
        size="sm"
    ></b-pagination>
    <div class="text-center mt-3">
      <b-link @click="goToTransactions">Go to transactions</b-link>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: {
    orders: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      fields: [
        {key: 'id', label: 'ID'},
        {key: 'date', label: 'Date'},
        {key: 'type', label: 'Payment Method'},
        {key: 'status', label: 'Status'},
        {key: 'price', label: 'Price'}
      ],
      currentPage: 1,
      perPage: 10,
      windowWidth: window.innerWidth
    }
  },
  computed: {
    // Проверка, является ли устройство мобильным
    isMobile() {
      return this.windowWidth < 768
    },
    // Форматирование список заказов с преобразованием валюты и статусов
    formattedOrders() {
      return this.orders.map(order => {
        // Форматирование валюты
        let currencySymbol = '';
        if (order.price && order.price.currency) {
          switch (order.price.currency) {
            case 'RUB':
              currencySymbol = '₽';
              break;
            case 'USD':
              currencySymbol = '$';
              break;
            case 'EUR':
              currencySymbol = '€';
              break;
            default:
              currencySymbol = order.price.currency;
          }
        }

        // Форматирование статуса заказа
        let displayStatus = '';
        if (order.status) {
          switch (order.status) {
            case 'pre_order':
              displayStatus = "request";
              break;
            case 'owner_approved':
            case 'new':
              displayStatus = "to pay";
              break;
            case 'paid':
            case 'ready_to_publish':
            case 'awaiting_charts':
            case 'adding_charts':
              displayStatus = "processing";
              break;
            case 'download_charts':
              displayStatus = "downloading"
              break;
            case 'complete':
              displayStatus = "complete";
              break;
            case 'cancelled_by_distirbutor':
              displayStatus = "cancelled";
              break;
            case 'error':
              displayStatus = "error";
              break;
            default:
              displayStatus = order.status;
          }
        }

        return {
          id: order.displayId || '',
          date: order.updatedAt ? new Date(order.updatedAt).toLocaleDateString() : '',
          type: order.paymentMethod?.paymentMethod || '',
          status: displayStatus,
          price: order.price ? `${order.price.price} ${currencySymbol}` : ''
        };
      });
    },
    // Пагинация для отображения только части заказов
    paginatedOrders() {
      const start = (this.currentPage - 1) * this.perPage;
      const end = start + this.perPage;
      return this.formattedOrders.slice(start, end);
    }
  },
  mounted() {
    // Установка слушателя события изменения размера окна
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    // Удаление слушателя события изменения размера окна
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    // Обработчик изменения размера окна
    handleResize() {
      this.windowWidth = window.innerWidth;
      this.$forceUpdate();
    },
    // Переход к странице транзакций
    goToTransactions() {
      this.$bvModal.hide('orders-modal');
      this.$router.push('/transactions');
    },
    // Получение варианта статуса для отображения в виде беджа
    getStatusVariant(status) {
      switch (status.toLowerCase()) {
        case 'complete':
          return 'success';
        case 'processing':
          return 'primary';
        case 'to pay':
          return 'warning';
        case 'request':
          return 'info';
        case 'cancelled':
        case 'error':
          return 'danger';
        default:
          return 'secondary';
      }
    },
  },
}
</script>

<style scoped>
.mobile-orders-list {
  max-height: 60vh;
  overflow-y: auto;
}

.order-card {
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.order-card .card-header {
  background-color: rgba(0, 0, 0, 0.03);
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
}
</style>